<template>{{ prefix ? prefix + ' ' : '' }}{{ ago }}</template>
<script setup lang="ts">
import { useUser } from '@/stores/user'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			minAgo: '{0} min. ago',
			hourAgo: '{n} hour ago | {n} hours ago',
			dayAgo: '{n} day ago | {n} days ago',
			monthAgo: '{n} month ago | {n} months ago'
		},
		ru: {
			minAgo: '{0} мин. назад',
			hourAgo:
				'{n} часов назад | {n} час назад | {n} часа назад | {n} часов назад',
			dayAgo:
				'{n} дней назад | {n} день назад | {n} дня назад | {n} дней назад',
			monthAgo:
				'{n} месяцев назад | {n} месяц назад | {n} месяца назад | {n} месяцев назад'
		}
	}
})

const props = defineProps<{
	date: Date
	prefix?: string
}>()

const user = useUser()

const ago = computed(() => {
	const diff = user.now() - props.date.getTime()
	const minutes = Math.floor(diff / 60000)

	if (minutes < 60) {
		return t('minAgo', [minutes])
	}

	const hours = Math.floor(minutes / 60)

	if (hours < 24) {
		return t('hourAgo', hours)
	}

	const days = Math.floor(hours / 24)

	if (days < 31) {
		return t('dayAgo', days)
	}

	const months = Math.floor(days / 30)

	return t('monthAgo', months)
})
</script>
